import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality — ONLY on the Agent Portal
// subdomain. Registering on the public marketing site caused stale JS chunks
// to be mixed with a fresh main bundle on first load after a redeploy, which
// crashed React with Minified error #300 ("Rendered fewer hooks than expected").
if (
  process.env.NODE_ENV === 'production' &&
  window.location.hostname.startsWith('agent.')
) {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      // Show update notification to user
      const updateAvailable = window.confirm(
        'A new version of Agent Portal is available. Reload to update?'
      );
      if (updateAvailable && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    },
    onSuccess: () => {
      console.log('Agent Portal is ready for offline use!');
    }
  });
}
